export default __webpack_public_path__ + "224016c28f6aedf07eb03f2cf9ed81b0.svg";